/* eslint-disable */
import axios from "axios"

export default {
  methods: {
    /**
     * Traz combo de Servicos
     * @param {Number} id
     * @return {
     *   "Servico": [
     *   {
     *    "id": 0,
     *    "tipoServico": "string"
     *   }
     *  ]
     * }
     */
    getServicos(form_name) {
      return axios.get(
        this.CriarUrl({
          resource: `servico?rnpTipoFormulario=${form_name}`
        })
      );
    },
  }
}